import { CLEAR_LIST_VIDEO_LIBRARY, CREATE_VIDEO, CREATE_VIDEO_CLEAR, CREATE_VIDEO_ERROR, CREATE_VIDEO_SUCCESS, EXPORT_VIDEO_LIBRARY_REPORT, EXPORT_VIDEO_LIBRARY_REPORT_ERROR, EXPORT_VIDEO_LIBRARY_REPORT_SUCCESS, GET_LIST_VIDEO_LIBRARY, GET_LIST_VIDEO_LIBRARY_ERROR, GET_LIST_VIDEO_LIBRARY_SUCCESS, GET_VIDEO, GET_VIDEO_CLEAR, GET_VIDEO_ERROR, GET_VIDEO_SUCCESS, REMOVE_VIDEO, REMOVE_VIDEO_CLEAR, REMOVE_VIDEO_ERROR, REMOVE_VIDEO_SUCCESS, UPDATE_VIDEO, UPDATE_VIDEO_CLEAR, UPDATE_VIDEO_ERROR, UPDATE_VIDEO_SUCCESS } from "./actionTypes";
import { DEFAULT_OFFSET } from "../../../constants/pagination";

const initialState = {
  data: [],
  item: null,
  created: null,
  updated: null,
  removed: null,
  changedStatus: null,
  pagination: { totalCount: 0, nextOffset: DEFAULT_OFFSET },
  error: "",
  loading: false,
  loadingGetVideo: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_VIDEO_LIBRARY:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_LIST_VIDEO_LIBRARY_SUCCESS:
      state = {
        ...state,
        data: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
      break;
    case GET_LIST_VIDEO_LIBRARY_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CLEAR_LIST_VIDEO_LIBRARY:
      state = { ...initialState };
      break;
    case GET_VIDEO:
      state = {
        ...state,
        loadingGetVideo: true,
      };
      break;
    case GET_VIDEO_SUCCESS:
      state = {
        ...state,
        item: action.payload,
        loadingGetVideo: false,
      };
      break;
    case GET_VIDEO_ERROR:
      state = {
        ...state,
        loadingGetVideo: false,
      };
      break;
    case GET_VIDEO_CLEAR:
      state = {
        ...state,
        // data: [],
        item: null,
        loadingGetVideo: false,
      };
      break;
    case CREATE_VIDEO:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CREATE_VIDEO_SUCCESS:
      state = {
        ...state,
        created: action.payload,
        loading: false,
      };
      break;
    case CREATE_VIDEO_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CREATE_VIDEO_CLEAR:
      state = {
        ...state,
        created: null,
      };
      break;
    case UPDATE_VIDEO:
      state = {
        ...state,
        loading: true,
      };
      break;
    case UPDATE_VIDEO_SUCCESS:
      state = {
        ...state,
        updated: action.payload,
        loading: false,
      };
      break;
    case UPDATE_VIDEO_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case UPDATE_VIDEO_CLEAR:
      state = {
        ...state,
        updated: null,
      };
      break;
    case REMOVE_VIDEO:
      state = {
        ...state,
        loading: true,
      };
      break;
    case REMOVE_VIDEO_SUCCESS:
      state = {
        ...state,
        removed: action.payload,
        loading: false,
      };
      break;
    case REMOVE_VIDEO_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case REMOVE_VIDEO_CLEAR:
      state = {
        ...state,
        removed: null,
      };
      break;

    case EXPORT_VIDEO_LIBRARY_REPORT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case EXPORT_VIDEO_LIBRARY_REPORT_SUCCESS:
      state = {
        ...state,
        // removed: action.payload,
        loading: false,
      };
      break;
    case EXPORT_VIDEO_LIBRARY_REPORT_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
